interface SchedulingDetailPageProps {
  siteKey: string;
  resourcesListView: React.ReactNode;
  detailView: React.ReactNode;
  filtersAndButtons: React.ReactNode;
  optimizeResultsSection: React.ReactNode;
  children: {
    noTasksForSelectedDate: React.ReactNode;
  };
}

export default function SchedulingDetailPage(props: SchedulingDetailPageProps) {
  if (props.children.noTasksForSelectedDate) {
    return (
      <section>
        {props.filtersAndButtons}
        {props.children.noTasksForSelectedDate}
      </section>
    );
  }

  return (
    <section>
      {props.filtersAndButtons}
      {props.optimizeResultsSection}
      <div className="mt-3 flex items-start gap-2">
        <div className="w-64">{props.resourcesListView}</div>
        {props.detailView} {/* SchedulingDetailResourceView.tsx */}
      </div>
    </section>
  );
}
